<template>
  <v-app>
    <div id="settings">
      <div class="container-1800">
        <div class="content ml-auto mr-auto">

          <header class="d-flex justify-content-between align-center">
            <h1>{{ $t('pages.settings.title') }}</h1>
          </header>

          <el-tabs v-model="activeTab">
            <el-tab-pane name="branding" lazy>
              <span slot="label" class="text-uppercase">
                {{ $t('pages.settings.tabs.branding') }}
              </span>
              <branding-tab />
            </el-tab-pane>
            <el-tab-pane name="users" lazy>
              <span slot="label" class="text-uppercase">
                {{ $t('pages.settings.tabs.users') }}
              </span>
              <users-tab />
            </el-tab-pane>
          </el-tabs>

        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import BrandingTab from './components/BrandingTab.vue'
import UsersTab from './components/UsersTab.vue'

export default {
  name: 'Settings',

  components: { BrandingTab, UsersTab },

  // TODO: introduce hash-based active-tab sync (à la IdeaCollection.vue) once a second tab lands.
  data () {
    return {
      activeTab: 'branding'
    }
  },

  computed: {
    ...mapGetters('appSettings', ['canEditBranding', 'whitelabelEnabled']),
    ...mapGetters('user', ['isTemplateAdmin', 'isWhitelabelAdmin']),
    ...mapState('appSettings', ['loaded'])
  },

  watch: {
    loaded: {
      immediate: true,
      handler (val) {
        if (val) this.enforceAccess()
      }
    }
  },

  created () {
    this.enforceAccess()
  },

  methods: {
    enforceAccess () {
      if (this.whitelabelEnabled && (this.isTemplateAdmin || this.isWhitelabelAdmin)) return

      if (!this.loaded && !this.whitelabelEnabled) return

      if (!this.canEditBranding) {
        this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#settings {
  margin-left: 0;
}

.content {
  padding: 24px 0;
}
</style>
